import { gql } from '@apollo/client';

export const MA_OPPORTUNITIES_SUMMARY_QUERY = gql`
  query maOpportunitiesSummary($filters: MaFilters) {
    maOpportunitiesSummary(filters: $filters) {
      count
      medianValuation
      medianReserves
      medianProduction
      medianCapex
    }
  }
`;

export const MA_OPPORTUNITIES_AGGREGATES_QUERY = gql`
  query maOpportunitiesAggregates(
    $by: MaAggregateByEnum!
    $filters: MaFilters
    $valuationsSum: Boolean!
    $reservesSum: Boolean!
    $productionsSum: Boolean!
    $acquisitionCostSum: Boolean!
    $countSum: Boolean!
  ) {
    maOpportunitiesAggregates(by: $by, filters: $filters) {
      type
      group
      valuationsSum @include(if: $valuationsSum)
      reservesSum @include(if: $reservesSum)
      productionsSum @include(if: $productionsSum)
      acquisitionCostSum @include(if: $acquisitionCostSum)
      countSum @include(if: $countSum)
    }
  }
`;

export const MA_OPPORTUNITIES_AGGREGATES_STACKED_QUERY = gql`
  query maOpportunitiesAggregatesStacked(
    $by: MaAggregateByEnum!
    $stackBy: MaStackByEnum!
    $fields: [String!]!
    $filters: MaFilters
  ) {
    maOpportunitiesAggregatesStacked(
      by: $by
      stackBy: $stackBy
      fields: $fields
      filters: $filters
    ) {
      stacks
      data {
        type
        group
        values
      }
    }
  }
`;
